import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import StatusStafModal from "../components/StatusStafModal";
import ActiveButton from "../../../../CommonElements/Button/ActiveButton";

const StatusStafColumns = (resetState, toggleActivate) => [
  {
    name: <DataTableTitle text={"ID"} />,
    selector: (row) => row.id_status_staf,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Status Staf"} />,
    selector: (row) => row.nama_status_staf,
    sortable: true,
    wrap: true,
  },
  {
    name: <DataTableTitle text={"Operasi"} />,
    width: "15%",
    cell: (row) => (
      <div>
        <StatusStafModal create={false} data={row} resetState={resetState} />
        &nbsp;&nbsp;
        <ActiveButton
          isActive={Boolean(row?.is_active)}
          toggle={() => toggleActivate(row?.id_status_staf)}
        />
      </div>
    ),
  },
];

export default StatusStafColumns;
